import * as THREE from 'three';

export const LIGHTMAP_SCENE_EXPORT_COORDINATE_SYSTEM = 'Blender Z-up' as const;

export function threeToBlenderPositionArray(x: number, y: number, z: number): [number, number, number] {
  return [x, -z, y];
}

export function threeToBlenderDirectionArray(direction: THREE.Vector3): [number, number, number] {
  return threeToBlenderPositionArray(direction.x, direction.y, direction.z);
}

export function threeMatrixWorldToBlenderArray(matrix: THREE.Matrix4): number[] {
  const elements = matrix.elements;
  return [
    elements[0]!, -elements[8]!, elements[4]!, elements[12]!,
    -elements[2]!, elements[10]!, -elements[6]!, -elements[14]!,
    elements[1]!, -elements[9]!, elements[5]!, elements[13]!,
    elements[3]!, -elements[11]!, elements[7]!, elements[15]!,
  ];
}

export function threeMatrixWorldToBlenderTransform(matrix: THREE.Matrix4): {
  position: [number, number, number];
  rotation: [number, number, number];
  scale: [number, number, number];
} {
  const position = new THREE.Vector3();
  const quaternion = new THREE.Quaternion();
  const scale = new THREE.Vector3();
  matrix.decompose(position, quaternion, scale);
  const blenderPosition = threeToBlenderPositionArray(position.x, position.y, position.z);
  const blenderQuaternion = new THREE.Quaternion(quaternion.x, -quaternion.z, quaternion.y, quaternion.w);
  const blenderEuler = new THREE.Euler().setFromQuaternion(blenderQuaternion, 'XYZ');
  return {
    position: blenderPosition,
    rotation: [blenderEuler.x, blenderEuler.y, blenderEuler.z],
    scale: [scale.x, scale.z, scale.y],
  };
}
